import { bisectCenter } from './bisects/bisect-center/bisectCenter';

type Row = Record<string, unknown>;
export type TooltipRow = { position: number; row: Row };

/** Sort a separate index, never caller data; only currently visible samples participate. */
export const prepareTooltipRows = (data: Row[], key: string, scale?: (value: unknown) => number | undefined): TooltipRow[] => {
  if (!scale) return [];
  return data.flatMap(row => {
    const position = scale(row[key]);
    return position !== undefined && Number.isFinite(position) && position >= 0 && position <= 100
      ? [{ position, row }] : [];
  }).sort((a, b) => a.position - b.position);
};

export const findTooltipRow = (rows: TooltipRow[], position: number): Row | undefined =>
  rows.length && Number.isFinite(position) ? rows[bisectCenter(rows, 'position', position)]?.row : undefined;
